// extracted by mini-css-extract-plugin
export var link = "Link-module--link--2u5hO";
export var linkReverse = "Link-module--linkReverse--nAl_7";
export var linkEmphasisLow = "Link-module--linkEmphasisLow--2xzp9";
export var linkEmphasisMedium = "Link-module--linkEmphasisMedium--1q9u5";
export var linkEmphasisHigh = "Link-module--linkEmphasisHigh--3guaH";
export var show = "Link-module--show--1p2QT";
export var showFadeInDown = "Link-module--show-fade-in-down--3FCLu";
export var showFadeInUp = "Link-module--show-fade-in-up--3snPC";
export var hideFadeOut = "Link-module--hide-fade-out--1ahwv";